import {
  CORE_LOAD_EVENTINCOMING_REQUEST,
  CORE_LOAD_EVENTINCOMING_SUCCESS,

  CORE_LOAD_EVENTHISTORY_REQUEST,
  CORE_LOAD_EVENTHISTORY_SUCCESS,

  CORE_LOAD_EVENTCALENDAR_SUCCESS,
  CORE_LOAD_EVENTCALENDAR_REQUEST,
} from '../../types'


const initialState = []
export default {
  eventIncoming: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_EVENTINCOMING_REQUEST:
        return initialState
      case CORE_LOAD_EVENTINCOMING_SUCCESS:
        if (typeof (action.payload[0]) !== "undefined")
        
          return action.payload[0]
        else return [{}]

default:
  return state
    }
  },
  eventHistory: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_EVENTHISTORY_REQUEST:
        return initialState
      case CORE_LOAD_EVENTHISTORY_SUCCESS:
      if (typeof (action.payload[0]) !== "undefined")

        return action.payload[0]
      else return [{}]
default:
  return state
    }
  },
  eventCalendar: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_EVENTCALENDAR_REQUEST:
        return initialState
      case CORE_LOAD_EVENTCALENDAR_SUCCESS:
      if (typeof (action.payload[0]) !== "undefined")
        return action.payload[0]
      else return {}
default:
  return state
    }
  },
}


// WEBPACK FOOTER //
// ./src/front/features/mybookings/reducer.js